import React, { useState, useEffect } from 'react';
import moreinfoImg from '../../images/moreInfo.png';
import closeImg from '../../images/close.png';

const MoreInfo = props => {

  return (
    <div className="MoreInfo">
      <img src={moreinfoImg}/>
      <img src={closeImg} className="MoreInfo_cancel-button" onClick={()=>props.closeModal(false)}/>

      <br/>
      <h3>Brand Affinity</h3>
      <span>
      The Brand Affinity Insights are a measurement of this audiences brand preferences versus the media publishers wider audience i.e. of the audience that saw this campaign how does their brands preferences positively and negatively compared to the total audience of this media publisher
      </span>
    </div>
  );
};

export default MoreInfo;
